import * as React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Text } from '@lightspeed/flame/Text';

import ProgressAsyncJob from 'root/apps/components/ProgressAsyncJob/ProgressAsyncJob';
import { ReconcileDataContext } from 'root/apps/InventoryCountReconcile/contexts/ReconcileData';

interface Props {
  fetchInterval?: number;
}

const ProgressView: React.FC<Props> = ({ fetchInterval = 3000 }) => {
  const { data, getReconcileData } = React.useContext(ReconcileDataContext);
  const [progress, setProgress] = React.useState(0);
  const [totalBatches, setTotalBatches] = React.useState(0);

  React.useEffect(() => {
    if (data && data.progress !== undefined && data.totalBatches !== undefined) {
      setProgress(data.progress);
      setTotalBatches(data.totalBatches);
    }
    const interval = setInterval(() => {
      getReconcileData();
    }, fetchInterval);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.progress, data?.totalBatches]);

  return (
    <Box data-test="progress-view" px={5} py={50} height={180}>
      <Flex flexDirection="column" justifyContent="space-between" alignItems="center" height="100%">
        <Text size="large" fontWeight={600} color={theme.colors.black}>
          Reconciling inventory
        </Text>
        <Box textAlign="center" pb={2}>
          <Text>You can safely navigate away from this page.</Text>
        </Box>
        <ProgressAsyncJob progress={progress} totalBatches={totalBatches} />
      </Flex>
    </Box>
  );
};

export default ProgressView;
